module.exports = __webpack_public_path__ + "img/rotate-arrow-to-the-left.018745dd.svg";